import { BaseModel } from '../base/base.model';

/**
 * The base user class
 */
export class BaseUser extends BaseModel {
  /** The user's first name */
  public firstName: string;

  /** The user's last name */
  public lastName: string;

  /** Get accessor for the user's full name */
  public get fullName(): string {
    return this.firstName + ' ' + this.lastName;
  }

  /** The user's email address */
  public email: string;

  /** An array containing the user's roles */
  public roles: string[] = [];
}
